import { render, staticRenderFns } from "./TermManageDialog.vue?vue&type=template&id=5438b8da&scoped=true"
import script from "./TermManageDialog.vue?vue&type=script&lang=js"
export * from "./TermManageDialog.vue?vue&type=script&lang=js"
import style0 from "./TermManageDialog.vue?vue&type=style&index=0&id=5438b8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438b8da",
  null
  
)

export default component.exports